import { useEffect } from 'react'
import { useReconnect } from 'wagmi'

/**
 * Reconnect wallet when user returns to tab or switches account (fixes mobile + desktop).
 */
export function ReconnectOnVisibility() {
  const { reconnect } = useReconnect()

  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === 'visible') reconnect()
    }
    document.addEventListener('visibilitychange', onVisible)

    const ethereum = typeof window !== 'undefined' && window.ethereum
    const onAccountsChanged = () => {
      reconnect()
    }
    if (ethereum?.on) {
      ethereum.on('accountsChanged', onAccountsChanged)
      ethereum.on('chainChanged', onAccountsChanged)
    }

    return () => {
      document.removeEventListener('visibilitychange', onVisible)
      if (ethereum?.removeListener) {
        ethereum.removeListener('accountsChanged', onAccountsChanged)
        ethereum.removeListener('chainChanged', onAccountsChanged)
      }
    }
  }, [reconnect])

  return null
}
